import $ from 'jquery';

export default {

	init() {


		var formExist = document.getElementsByClassName('page-template-template-signup');
		if (formExist.length > 0) {

			// Select Dropdown to show Provinces or States
			$('.country_auto option[data-id="233"]').insertBefore('.country_auto option[data-id="1"]');


			document.addEventListener( 'wpcf7mailsent', function( event ) {

				$('.wpcf7-form').fadeOut('fast', function() {
					$('#FormSuccess').fadeIn('fast');
				});


			}, false );

			$( ".wpcf7-submit" ).wrap( "<div class='submit-wrap'></div>" );
			$( ".wpcf7-submit" ).wrap( "<div class='group submit-wrap-button'></div>" );

			// Check if Salesforce form was submited

				var url = new URL(window.location.href);

				if (url.searchParams.has('form')) {
		
					$('.wpcf7-form').fadeOut('fast', function() {
						$('#FormSuccess').fadeIn('fast');
					});
					$('.salesforce-form').fadeOut('fast', function() {
						$('#FormSuccess').fadeIn('fast');
					});			
		
				}
			

		}
	}
}
